import React, { Component } from 'react';
import {Modal,ModalBody,Input,Button} from 'reactstrap';
import Select from 'react-select';
import find from 'lodash/find';
import {connect} from 'react-redux';
import OoPopover from '../../../components/UI/Popover/OoPopover';
import MappedIcon from './../../../assets/office_created_icon.svg'
import axios from '../../../axios';
import * as  url from './../../../utils/url';
import * as actionCreators from './../../../modules/actions/index';



class EnterpriseSettings extends Component {
  constructor(props) {
    super(props);
    console.log("this props - ", this.props)

    this.state = {
        isEmailList: this.props.isEmailList
  }
}

  
  handleEnterpriseRule = event => {
    console.log(event.target.value)
    this.setState({ enterpriseRule: {value:event.target.value }});
  };

  closeEmailList=()=>{
      this.setState({isEmailList: false})
  }


  handleEmailListSave =()=>{

  }


  render() { 
    const {isEmailList} = this.props;
    // let showModal = isEmailList
    console.log(this.props, this.state, "inside email list")
    return ( 
      <div className="mt40">
       
      
        <Modal 
          isOpen={isEmailList} 
          className="drill-down-modal">
          <ModalBody>
           
            <div className="row mt20">
              <div className="offset-md-1 offset-lg-1 pick-office-modal-body-title">
                Edit Enterprise Information
              </div>
            </div>


            <Button className="profile-modal-save-btn" 
                      onClick={this.handleEmailListSave}>
                        <span className="profile-modal-save-btn-txt">Save
                        <span className="ml10 flaticon-tick"></span></span>
                    </Button>

            <Button 
                className="profile-modal-cancel-btn"
                onClick={this.closeEmailList}>
                <span className="profile-modal-cancel-btn-txt">Cancel</span>
           </Button>
         
          </ModalBody>
        </Modal>
      
      </div>
    );
  }
}
 
const mapStateToProps = (state) => {
  return {
    orgEmail : state.user.profile.organizationId.emailDomains
  }
}

const mapDispatchToProps = dispatch => {
	return {
    orgChangeSuccess: (data)=> dispatch(actionCreators.orgChangeSuccess(data)),
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(EnterpriseSettings);